// Tarayıcı çevirisi / eklentiler React'in yönettiği DOM'u değiştirdiğinde (metin düğümlerini <font> ile sarma vb.)
// React 19 commit aşamasında removeChild/insertBefore "not a child of this node" hatası fırlatır ve tüm ağacı kaldırır (beyaz ekran).
// Bu koruma, gerçek ebeveyni farklı olan düğümler için işlemi güvenli şekilde tamamlar.
export function installDomGuard() {
  if (typeof Node === "undefined" || Node.prototype.__hakedisGuard) return;
  const origRemove = Node.prototype.removeChild;
  const origInsert = Node.prototype.insertBefore;
  Node.prototype.removeChild = function (child) {
    if (child && child.parentNode !== this) {
      if (child.parentNode) child.parentNode.removeChild(child);
      return child;
    }
    return origRemove.call(this, child);
  };
  Node.prototype.insertBefore = function (newNode, ref) {
    if (ref && ref.parentNode !== this) return this.appendChild(newNode);
    return origInsert.call(this, newNode, ref);
  };
  Node.prototype.__hakedisGuard = true;
}
